import { combineReducers } from 'redux-immutable';
import formDuck from './ducks/formDuck';
import requestDuck from './ducks/requestDuck';
import filtersDuck from './ducks/filtersDuck';

export default combineReducers({
  form: formDuck,
  request: requestDuck,
  filters: filtersDuck,
});
